import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle, defaultContext, colors } from './seekBar.style';

export class SeekBar extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        PlayHeadBar: {
          rect: true,
        },
        PlayHeadBarOverlay: {
          rect: true,
        },
        ProgressBar: {
          rect: true,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _build() {
    this.progress = 0;
    this.playHead = 0;
  }

  get playHead() {
    return this._playHead;
  }

  set playHead(value) {
    this._playHead = value;
    this.tag('PlayHeadBar').scaleX = value;
    this.tag('PlayHeadBarOverlay').scaleX = value;
  }

  set isLive(value) {
    this.tag('ProgressBar').color = value ? colors.live[this._style.colorMode] : colors.progress[this._style.colorMode];
  }

  get progress() {
    return this._progress;
  }

  set progress(value) {
    this._progress = value;
    this.tag('ProgressBar').scaleX = value;
  }
}
